module.exports = {
  "container": {
    "alignItems": "center",
    "justifyContent": "center"
  },
  "dofModalWrapper": {
    "position": "fixed",
    "top": "0",
    "bottom": "0",
    "left": "0",
    "right": "0",
    "alignItems": "center",
    "justifyContent": "center",
    "zIndex": 1000
  },
  "modal-box": {
    "width": "540",
    "zIndex": 100,
    "position": "relative"
  },
  "modal-content": {
    "paddingTop": "36",
    "paddingBottom": "32",
    "paddingLeft": "32",
    "paddingRight": "32",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "content-title": {
    "fontFamily": "PingFangSC-Medium",
    "color": "#1e2e37",
    "fontSize": "32",
    "textAlign": "center",
    "lineHeight": "48",
    "lines": 1,
    "textOverflow": "ellipsis",
    "overflow": "hidden",
    "wordBreak": "break-all"
  },
  "content-image": {
    "width": "476",
    "height": "476"
  },
  "content-subtext": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "26",
    "lineHeight": "32",
    "marginTop": "16",
    "textAlign": "center"
  },
  "search-bar-input": {
    "paddingTop": 0,
    "paddingBottom": 0,
    "paddingRight": "10",
    "paddingLeft": "10",
    "marginTop": "40",
    "fontSize": "28",
    "width": "476",
    "height": "72",
    "lineHeight": "72",
    "backgroundColor": "#F6F7F9",
    "placeholderColor": "#8c8c8c",
    "border:active": "1px solid #9f9f9f !important"
  },
  "modal-footer": {
    "flexDirection": "row",
    "alignItems": "center",
    "borderTopWidth": "1"
  },
  "footer-btn": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "flex": 1,
    "height": "90",
    "position": "relative"
  },
  "cancel": {
    "borderRightWidth": "1"
  },
  "btn-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "36",
    "color": "#616c73"
  },
  "more-btn": {
    "flexDirection": "column"
  },
  "footer-more-btn": {
    "alignItems": "center",
    "justifyContent": "center",
    "height": "90",
    "borderTopWidth": "1",
    "position": "relative"
  },
  "closeIconBox": {
    "position": "absolute",
    "width": "60",
    "height": "60",
    "top": "25",
    "right": 0
  },
  "closeIcon": {
    "position": "absolute",
    "width": "20",
    "height": "20",
    "bottom": "0",
    "left": "0"
  },
  "closeIconFont": {
    "position": "absolute",
    "left": 0,
    "bottom": 0
  },
  "mask": {
    "position": "absolute",
    "top": "0",
    "right": "0",
    "bottom": "0",
    "left": "0"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-3a9973ca!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-modal/index.vue
// module id = 463
// module chunks = 0 1